import { styled } from 'styled-components';
import { theme } from '../../styles';
import { Container, Backdrop } from '../.';
import { CloseCircleIcon } from '../../assets/svg';

const ImageModal = ({ open, handleClose, image }) => {
  if (open)
    return (
      <Backdrop
        onClick={() => handleClose()}
        initial={theme.fadeIn.initial}
        animate={theme.fadeIn.animate}
        exit={theme.fadeIn.initial}
        transition={theme.fadeIn.transition(0)}
      >
        <Container>
          <CloseButton onClick={() => handleClose()}>
            <CloseCircleIcon />
          </CloseButton>
          <OpenImage src={require(`../../assets/${image}.png`)} />
        </Container>
      </Backdrop>
    );
};

export default ImageModal;

const OpenImage = styled.img`
  height: 80vh;
  width: auto;
  align-self: center;
`;

const CloseButton = styled.button`
  width: fit-content;
  padding: 0;
  margin: 0;

  display: block;
  align-self: end;

  color: ${props => props.theme.mutedColor};
  background: none;
  border: none;

  &:hover {
    color: ${props => props.theme.textColor};
  }
`;
